export const CHECKOUT_STEPS = {
    STEP_INITIALIZATION: 0,
    STEP_ADDRESS: 1,
    STEP_CARRIER: 2,
    STEP_PAYMENT: 3,
};
